var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Box, Container } from '@bfa/common-ui';
import { useScrollFromAnchor } from '@bfa/nextjs-common/hooks';
import { IpsyTheme } from '@bfa/themes';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { NotificationType } from '../../../../../types/enums';
import { createNotificationMessage } from '../../../../../utils/subscription';
import { UpsellContextProvider } from './Context';
import borderImage from './images/border.png';
import UpsellCategory from './UpsellCategory';
import useUpsellByCategories from './useUpsellByCategories';
var StyledSeparator = styled(Box)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: 1.4rem;\n  width: 100%;\n  background-image: url(", ");\n  background-repeat: repeat-x;\n  background-size: contain;\n"], ["\n  height: 1.4rem;\n  width: 100%;\n  background-image: url(", ");\n  background-repeat: repeat-x;\n  background-size: contain;\n"])), borderImage);
var UpsellByCategories = function (_a) {
    var subscription = _a.subscription, setAddItemMessage = _a.setAddItemMessage;
    var _b = useUpsellByCategories(), products = _b.products, upsellContent = _b.upsellContent, upsellProductModalContent = _b.upsellProductModalContent;
    var _c = upsellContent || {}, subscribeButtonText = _c.subscribeButtonText, subscribeAddedButtonText = _c.subscribeAddedButtonText, oneOffButtonText = _c.oneOffButtonText, oneOffAddedButtonText = _c.oneOffAddedButtonText, successMessage = _c.successMessage, errorMessage = _c.errorMessage, categories = _c.categories;
    var _d = __read(useState([]), 2), recentlyAdded = _d[0], setRecentlyAdded = _d[1];
    var _e = __read(useScrollFromAnchor('UpsellByCategories', 'smooth'), 1), scrollRef = _e[0];
    useEffect(function () {
        setRecentlyAdded([]);
    }, [products]);
    /**
     * Handle feedback when the product has be successfully added to users subscription.
     *
     * @param product - The added product.
     * @param deliveryMonth - The next delivery month.
     */
    var onAddItemSuccess = function (product, deliveryMonth) {
        setRecentlyAdded(function (prev) { return __spreadArray(__spreadArray([], __read(prev), false), [product.id], false); });
        setAddItemMessage(createNotificationMessage({
            copy: successMessage,
            product: product,
            type: NotificationType.SUCCESS,
            deliveryMonth: deliveryMonth,
        }));
    };
    /**
     * Handle feedback when the product was not able to be added to users subscription.
     *
     * @param product - The added product.
     */
    var onAddItemError = function (product) {
        setAddItemMessage(createNotificationMessage({
            copy: errorMessage,
            product: product,
            type: NotificationType.ERROR,
        }));
    };
    return (React.createElement(UpsellContextProvider, { value: {
            onAddItemSuccess: onAddItemSuccess,
            onAddItemError: onAddItemError,
            subscription: subscription,
        } },
        React.createElement(Box, { background: IpsyTheme.colors.refreshmentsBackground, width: "100%", "data-testid": "upsell-section" },
            React.createElement(StyledSeparator, { ref: scrollRef }),
            React.createElement(Container, { as: "section", background: IpsyTheme.colors.refreshmentsBackground, px: ['0', '1.5rem'] },
                React.createElement(Box, { backgroundColor: IpsyTheme.colors.refreshmentsBackground, paddingTop: "5rem", paddingBottom: ['1.5rem', '1rem'] }, categories === null || categories === void 0 ? void 0 : categories.map(function (category, index) { return (React.createElement(UpsellCategory, { key: +index, category: category, products: products, primaryCtaText: subscribeButtonText, secondaryCtaText: subscribeAddedButtonText, oneOffCtaText: oneOffButtonText, oneOffAddedCtaText: oneOffAddedButtonText, productModalContent: upsellProductModalContent, recentlyAdded: recentlyAdded })); }))))));
};
export default UpsellByCategories;
var templateObject_1;
